import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import { removerAcentos } from '../../../../../utils'
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import Carregando from '../../../../../Components/CustomUi/loading'
import { Tag } from 'antd'

interface PropsTabela {
  listar_comandos: any[]
  carregando_comandos: boolean
  setPagination?: React.Dispatch<React.SetStateAction<number>>
  page?: number
  setPage?: React.Dispatch<React.SetStateAction<number>>
  total: number
  excluir_comando: Function
  confirmar_exclusao: boolean
  buscarTabela: string
  abrir: Function
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  editar: Function
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
}

export const TabelaComando: React.FC<PropsTabela> = ({
  listar_comandos,
  carregando_comandos,
  setPagination,
  page,
  setPage,
  total,
  excluir_comando,
  confirmar_exclusao,
  fake_loading,
  id_item_atual,
  nome_item_atual,
  buscarTabela,
  setBuscarTabela,
  editar,
  setConfirmar_exclusao,
  setFake_loading,
  setId_item_atual,
  setNome_item_atual,
  abrir,
}) => {
  function buscarCargos(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <>
      <Inline alignItems='center'>
        <Input placeholder='Buscar cargos' value={buscarTabela} onChange={setBuscarTabela} />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
      </Inline>
      <HeaderTable
        itens={[
          { id: 1, valor: 'Usuário', width: 'calc(100% - 706px)' },
          { id: 2, valor: 'Descrição', width: '400px' },
          { id: 3, valor: 'Status', width: '130px' },
          { id: 4, valor: 'Ações', width: '170px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          marginTop: -10,
          height: listar_comandos?.length < 8 ? '100%' : 'calc(100vh - 280px)',
          position: 'relative',
          overflowX: 'hidden',
        }}
      >
        <Render condition={carregando_comandos === false}>
          {(listar_comandos ?? []).filter(buscarCargos(buscarTabela)).map((item) => {
            return (
              <RowTable key={item?.cod} onDoubleClick={() => editar(item?.cod)}>
                <RowItem width={'calc(100% - 706px)'} fontSize={13}>
                  {item?.usuario_nome}
                </RowItem>
                <RowItem width={'400px'} fontSize={13}>
                  {item?.descricao}
                </RowItem>
                <RowItem width={'130px'} fontSize={13}>
                  {item?.log !== null ? <Tag 
                    color={item?.null !== null && 'red'}
                    key={item?.cod}
                    style={{ margin: 5, fontSize: '11px' }}
                  >
                    {'Log'}
                  </Tag> : <Tag 
                    color={item?.executado === true ? 'green' : 'yellow'}
                    key={item?.cod}
                    style={{ margin: 5, fontSize: '11px' }}
                  >
                    {item?.executado === true ? 'Executado' : 'Pendente'}
                  </Tag>}
                </RowItem>
                <RowItem width={'176px'} gap={10}>
                  <DeleteButton
                    open={confirmar_exclusao && id_item_atual === item?.cod}
                    trigger={setConfirmar_exclusao}
                    onTrigger={() => {
                      setId_item_atual(item?.cod)
                      setNome_item_atual(item?.nome)
                    }}
                    loading={fake_loading}
                    message={`o item ${item?.nome} será excluido!`}
                    deleteds={[item?.nome]}
                    onDelete={() => {
                      excluir_comando(item?.cod)
                    }}
                    disabled={fake_loading}
                  />
                  <ButtonCustom
                    onClick={() => editar(item?.cod)}
                    icon={<FontAwesomeIcon icon={faEdit} />}
                  >
                    Editar
                  </ButtonCustom>
                </RowItem>
              </RowTable>
            )
          })}
        </Render>

        <Render condition={carregando_comandos}>
          <Carregando
            animation
            justifyContent='center'
            legenda='Buscando cargos...'
            size={'default'}
            height={350}
          />
        </Render>
      </BodyTable>
    </>
  )
}